import type {
  WaitlistApplyRequest,
  WaitlistApplyResponse,
  WaitlistStatusResponse,
} from '@eloquor/api-contract';
import { apiFetch } from './client';

export async function applyToWaitlist(req: WaitlistApplyRequest): Promise<WaitlistApplyResponse> {
  return apiFetch<WaitlistApplyResponse>('/waitlist', { method: 'POST', json: req });
}

export async function getWaitlistStatus(token: string): Promise<WaitlistStatusResponse> {
  return apiFetch<WaitlistStatusResponse>('/waitlist/status', {
    method: 'POST',
    json: { token },
  });
}
